<template>
    <div>
        <el-row :gutter="30">
            <el-col :xl="10">
                <div class="mt-20">
                    <h3 class="mt-0 mb-0 text-center">COPIES</h3>
                    <table class="w-full">
                        <thead>
                            <tr>
                                <td class="text-center">Quantity</td>
                                <td
                                    class="text-center"
                                    v-for="size in flatSizes"
                                >
                                    Color<br />
                                    {{ size.name }}
                                </td>
                                <td
                                    class="text-center"
                                    v-for="size in flatSizes"
                                >
                                    Black<br />
                                    {{ size.name }}
                                </td>
                                <td
                                    class="text-center"
                                    v-for="size in $root.$store.getters[
                                        Getters
                                            .WEEKLY_CALENDAR_AVAILABLE_FLAT_SIZES
                                    ]"
                                >
                                    Weekly<br />
                                    {{ size.name }}
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in computedPrices.flats">
                                <td class="text-center">{{ row.quantity }}</td>
                                <td v-for="price in row.prices">
                                    <div
                                        class="el-input el-input--minimal-padding"
                                    >
                                        <money
                                            v-model.number="price.price"
                                            v-bind="money"
                                            :disabled="
                                                !can(Permissions.EDIT_PRICING)
                                            "
                                            class="text-right el-input__inner"
                                        />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </el-col>
            <el-col :xl="14">
                <div class="mt-20">
                    <h3 class="mt-0 mb-0 text-center">POSTERS</h3>
                    <table class="w-full">
                        <thead>
                            <tr>
                                <td class="text-center">Quantity</td>
                                <td
                                    class="text-center"
                                    v-for="size in posterSizes"
                                >
                                    Color<br />
                                    {{ size.name }}
                                </td>
                                <td
                                    class="text-center"
                                    v-for="size in posterSizes"
                                >
                                    Black<br />
                                    {{ size.name }}
                                </td>
                                <td
                                    class="text-center"
                                    v-for="size in $root.$store.getters[
                                        Getters
                                            .WEEKLY_CALENDAR_AVAILABLE_POSTER_SIZES
                                    ]"
                                >
                                    Weekly<br />
                                    {{ size.name }}
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in computedPrices.posters">
                                <td class="text-center">{{ row.quantity }}</td>
                                <td v-for="price in row.prices">
                                    <div
                                        class="el-input el-input--minimal-padding"
                                    >
                                        <money
                                            v-model.number="price.price"
                                            v-bind="money"
                                            :disabled="
                                                !can(Permissions.EDIT_PRICING)
                                            "
                                            class="text-right el-input__inner"
                                        />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import * as Getters from "@/store/constants/getters";
import * as ColorTypes from "@/constants/color-types";
import * as OrderableTypes from "@/constants/orderable-types";
import { Money, VMoney } from "v-money";
import base_mixin from "./base";

export default {
    mixins: [base_mixin],
    props: {
        form: {
            type: Object,
            required: true,
        },
    },
    directives: { money: VMoney },
    components: {
        Money,
    },
    data() {
        return {
            Getters,
            ColorTypes,
            money: {
                decimal: ".",
                thousands: ",",
                prefix: "$ ",
                suffix: "",
                precision: 2,
                masked: true,
            },
        };
    },
    computed: {
        ...mapState({
            sizes: (state) => state.sizes.data,
            prices: (state) => state.prices.data,
            pricing: (state) => state.config.settings.pricing,
        }),
        ...mapGetters([
            Getters.FLAT_SIZES,
            Getters.POSTER_SIZES,
            Getters.WEEKLY_CALENDAR_AVAILABLE_FLAT_SIZES,
            Getters.WEEKLY_CALENDAR_AVAILABLE_POSTER_SIZES,
        ]),
        computedPrices() {
            let prices = {
                flats: [],
                posters: [],
            };
            prices.flats = _.map(
                this.pricing.quantities.calendars.flats,
                (quantity) => {
                    let prices = [];
                    let color_types = [
                        ColorTypes.COLORED,
                        ColorTypes.BLACK_AND_WHITE,
                    ];
                    _.forEach(color_types, (color_type) => {
                        _.forEach(this[Getters.FLAT_SIZES], (size) => {
                            let price = _.find(this.form.prices, {
                                ...this.basePriceAttributes,
                                orderable_type: OrderableTypes.CALENDAR,
                                size_id: size.id,
                                color_type,
                                quantity,
                                weekly_calendar: false,
                            });
                            if (!price) {
                                return;
                            }
                            prices.push(price);
                        });
                    });
                    // weekly calendar
                    _.forEach(
                        this[Getters.WEEKLY_CALENDAR_AVAILABLE_FLAT_SIZES],
                        (size) => {
                            let price = _.find(this.form.prices, {
                                ...this.basePriceAttributes,
                                orderable_type: OrderableTypes.CALENDAR,
                                size_id: size.id,
                                color_type: ColorTypes.COLORED,
                                quantity,
                                weekly_calendar: true,
                            });
                            if (price) {
                                prices.push(price);
                            }
                        }
                    );
                    return {
                        quantity,
                        prices,
                    };
                }
            );
            prices.posters = _.map(
                this.pricing.quantities.calendars.posters,
                (quantity) => {
                    let prices = [];
                    let color_types = [
                        ColorTypes.COLORED,
                        ColorTypes.BLACK_AND_WHITE,
                    ];
                    _.forEach(color_types, (color_type) => {
                        _.forEach(this[Getters.POSTER_SIZES], (size) => {
                            let price = _.find(this.form.prices, {
                                ...this.basePriceAttributes,
                                orderable_type: OrderableTypes.CALENDAR,
                                size_id: size.id,
                                color_type,
                                quantity,
                            });
                            if (!price) {
                                return;
                            }
                            prices.push(price);
                        });
                    });
                    _.forEach(
                        this[Getters.WEEKLY_CALENDAR_AVAILABLE_POSTER_SIZES],
                        (size) => {
                            let price = _.find(this.form.prices, {
                                ...this.basePriceAttributes,
                                orderable_type: OrderableTypes.CALENDAR,
                                size_id: size.id,
                                color_type: ColorTypes.COLORED,
                                weekly_calendar: true,
                                quantity,
                            });
                            if (price) {
                                prices.push(price);
                            }
                        }
                    );
                    return {
                        quantity,
                        prices,
                    };
                }
            );
            return prices;
        },
    },
};
</script>

<style scoped></style>
